<amp-time-series-widget
  [yAxisLabel]="'dashboardScope.dashboard.monitoring-speed.unit' | transloco"
  [yAxisSoftMax]="100"
  [data]="data$ | async"
  [dataUnit]="'d/min'"
  [averageLabel]="'dashboardScope.dashboard.monitoring-speed.average' | transloco"
>
</amp-time-series-widget>
